import {SideNavInterface} from '../../interfaces/side-nav.type';

export const ROUTES: SideNavInterface[] = [
  {
    path: '/dashboard',
    title: 'داشبورد',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: []
  },
  {
    path: '/hamzaman/list',
    title: 'همزمان',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
      {
        path: '/hamzaman/list',
        title: 'همزمان‌ها',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        submenu: []
      },
      {
        path: '/hamzaman/add',
        title: 'ایحاد همزمان',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        submenu: []
      },
    ]
  },
  {
    path: '/hamdoreh/list',
    title: 'هم‌دوره',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
      {
        path: '/hamdoreh/list',
        title: 'هم‌دوره‌ها',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        submenu: []
      },
      {
        path: '/hamdoreh/add',
        title: 'ایحاد هم‌دوره',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        submenu: []
      },
    ]
  },
  {
    path: '/promo-code/list',
    title: 'کد تخفیف',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
      {
        path: '/promo-code/list',
        title: 'کد تخفیف ها',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        submenu: []
      },
      {
        path: '/promo-code/add',
        title: 'ایحاد کد تخفیف',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'user',
        submenu: []
      },
    ]
  },
  {
    path: '/users/list',
    title: 'کاربران',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
      {
        path: '/users/list',
        title: 'همه کاربران',
        iconType: 'nzIcon',
        icon: 'usergroup-add',
        iconTheme: 'outline',
        submenu: [],
      },
      {
        path: '/users/teachers',
        title: 'مدرسین',
        iconType: 'nzIcon',
        icon: 'usergroup-add',
        iconTheme: 'outline',
        submenu: [],
      },
      {
        path: '/users/teachers/add',
        title: 'ایجاد مدرس',
        iconType: 'nzIcon',
        icon: 'usergroup-add',
        iconTheme: 'outline',
        submenu: [],
      },
      {
        path: '/users/add',
        title: 'افرودن کابر',
        iconType: 'nzIcon',
        icon: 'user-add',
        iconTheme: 'outline',
        submenu: []
      },
    ]
  },
  {
    path: '/payments/list',
    title: 'صورتحساب',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: []
  },
  {
    path: '/skyroom/users/list',
    title: 'اسکای‌روم',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: []
  },
  {
    path: '/ticket/all',
    title: 'تیکت ها',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: []
  },
  {
    path: '/blogs/list',
    title: 'پست',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
      {
        path: '/blogs/list',
        title: 'پست‌ها',
        iconType: 'nzIcon',
        icon: 'usergroup-add',
        iconTheme: 'outline',
        submenu: [],
      },
      {
        path: '/blogs/create',
        title: 'ایحاد پست',
        iconType: 'nzIcon',
        icon: 'user-add',
        iconTheme: 'outline',
        submenu: []
      },
    ]
  },
  {
    path: '/settings',
    title: 'تنظیمات',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: [
      {
        path: '/settings/home',
        title: 'تنظیمات صفحه اصلی',
        iconType: 'nzIcon',
        icon: 'usergroup-add',
        iconTheme: 'outline',
        submenu: [
          {
            path: '/settings/home/banner',
            title: 'بنر های صفحه خانه',
            iconType: 'nzIcon',
            icon: 'usergroup-add',
            iconTheme: 'outline',
            submenu: [],
          },
        ],
      },
    ]
  },
  {
    path: '/categories',
    title: 'دسته‌بندی',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: []
  },
  {
    path: '/tools',
    title: 'ابزار',
    iconType: 'nzIcon',
    iconTheme: 'outline',
    icon: 'user',
    submenu: []
  },
];
